import { View } from "binder"
import { HuntMediatorManipulationViewModel, HuntViewModel } from "./huntMediatorManipulation-viewModel"

export class HuntMediatorManipulationView extends View<HuntMediatorManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-41796FF8-16E0-4F1F-8C13-43F96D08FF7D"
    }
    loadHtml(): string {
        let element = require('./huntMediatorManipulation.html').default;
        let style = require('./huntMediatorManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set currentProduct(v: HuntViewModel) { this._currentProduct = v; } public get currentProduct(): HuntViewModel { return this._currentProduct;} private _currentProduct: HuntViewModel;
    
    back () {
        this.dataContext.back();
    }

    close() {
        this.dataContext.close();
    }

    confirm(){
        this.dataContext.confirm();
    }
}
